import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import { useEffect, useState } from "react";

export default function CustomProductCheckboxGroup({ ...props }) {
  const normalizeSelected = (value: any) => {
    if (Array.isArray(value)) {
      return value.filter(Boolean);
    }
    if (typeof value !== "string") {
      return [];
    }
    return value
      .split(/[|,]/)
      .map((item) => item.trim())
      .filter(Boolean);
  };

  const requiredSelectedIds: string[] = props?.requiredSelectedIds || [];
  const delimiter = props?.delimiter || ",";
  const buildNextSelected = (value: any) => {
    const normalized = normalizeSelected(value);
    return Array.from(new Set([...normalized, ...requiredSelectedIds]));
  };

  const [selected, setSelected] = useState<string[]>(
    buildNextSelected(props?.selected)
  );
  const optionlist = props.optionlist;

  useEffect(() => {
    setSelected(buildNextSelected(props?.selected));
  }, [props?.selected]);

  const handleChange = (id: any) => {
    const nextSelected = buildNextSelected(
      selected.includes(id)
        ? selected.filter((item) => item !== id)
        : [...selected, id]
    );
    setSelected(nextSelected);
    if (props?.handleChange) {
      props?.handleChange(nextSelected.join(delimiter));
    }
  };

  return (
    <FormGroup>
      {optionlist.map((option: any) => (
        <FormControlLabel
          key={option.id}
          sx={
            option?.level == "2"
              ? {
                  ml: 6,
                  "& .MuiFormControlLabel-label": {
                    // fontSize: "1.2rem",
                    // color: "red",
                  },
                }
              : {}
          }
          control={
            <Checkbox
              checked={selected.includes(option.id)}
              disabled={requiredSelectedIds.includes(option.id)}
              onChange={() => handleChange(option.id)}
            />
          }
          label={option.label}
        />
      ))}
    </FormGroup>
  );
}
